import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { GoalAnalysisService } from '../../services/goal-analysis.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'gp-cash-flow-table',
  templateUrl: './cash-flow-table.component.html',
  styleUrls: ['./cash-flow-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CashFlowTableComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;

  dataSource;
  //displayedColumns: string[] = ['c1Age', 'c2Age',  'c1EmpIncome', 'c2EmpIncome', 'totTax', 'totExpense'];
  //displayedColumns: string[] = ['yr', 'totSavings', 'portInc', 'totIncome', 'portTaxes', 'totExpense', 'totTax',  'netCashFlow'];
  //defaultDisplayedColumns: string[] = ['yr', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow', 'actions'];

  displayedColumnsC1Only: string[] = ['yr', 'c1Age', 'actions', 'portBeginBal', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow'];
  displayedColumnsC1C2: string[] = ['yr', 'c1Age', 'c2Age', 'actions', 'portBeginBal', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow'];
  displayedColumnsAdditionalWithC1Only: string[] = ['yr', 'c1Age', 'actions', 'portBeginBal', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow','portInc', 'c1Rmd', 'totWithdrawal', 'rmdTaxes', 'portTaxes', 'portEndBal'];
  displayedColumnsAdditionalWithC1C2: string[] = ['yr', 'c1Age', 'c2Age', 'actions', 'portBeginBal', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow', 'portInc', 'c1Rmd','c2Rmd', 'totWithdrawal', 'rmdTaxes', 'portTaxes', 'portEndBal'];

  displayedColumns; 
  //displayedColumns: string[] = ['yr', 'portBeginBal', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow', 'portInc', 'portTaxes', 'portEndBal'];
  //displayedColumns: string[] = ['yr', 'c1Age', 'c1EmpIncome', 'c1PreTaxSaving', 'c1AfterTaxSaving', 'totSavings', 'portTaxes', 'portInc', 'totTax', 'totExpense',  'capitalGL', 'netCashFlow'];


  //displayedColumns: string[] = ['yr', 'portBeginBal', 'totIncome', 'portInc', 'totExpense', 'totTax', 'portTaxes', 'totSavings', 'netCashFlow', 'portEndBal'];

  isDataAvailable = false;
  isAdditionalColumns = true;

  pClId;
  pClRetAge;
  sClId;
  sClRetAge;


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.displayedColumns, event.previousIndex, event.currentIndex);
  }

  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private goalAnalysisService: GoalAnalysisService,
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "CashFlowComponent-ngOnInit", true);
    this.dataService.getPlanAnalysis();        
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  private populateAppData(appData: fromModel.IAppData){
    this.dataSource = null;
    this.isDataAvailable = false;
    this.pClId = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientid;
    this.pClRetAge = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary).retAge;
    this.sClId = this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary)?this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary).clientid:null;
    this.sClRetAge = this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary)?this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary).retAge:null;
    this.displayedColumns = this.getDisplayedColumns();
    if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){        
      this.dataService.getGoalSummary();
      this.dataService.getPlanAnalysis();      
    }
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){      
      // let yoyCashFlows = this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.CASHFLOWTABLE});
      let yoyCashFlows = this.dataService.getPlanAnalysisyoyCashFlows();
      //let yoyCashFlows = this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.NETCASHFLOWSBYTEAR, year: this.year.value});
      if(yoyCashFlows!== null){
        if(yoyCashFlows.Error){
          this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "CashFlowComponent-populateAppData - Error", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});                    
        } else {
          this.dataSource =  yoyCashFlows;          
          this.isDataAvailable = true;
          this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "CashFlowComponent-populateAppData", false);
        }
      }
    }
  }

  showAdditionalColumns()
  {
    this.isAdditionalColumns = !this.isAdditionalColumns;
    // if(this.isAdditionalColumns){
    //   this.displayedColumns = this.defaultDisplayedColumns;
    // } else {
    //   this.displayedColumns = ['yr', 'c1Age', 'c2Age', 'actions', 'portBeginBal', 'totIncome', 'totExpense', 'totTax', 'totSavings', 'netCashFlow'];
    // }

    this.displayedColumns = this.getDisplayedColumns();
    let yoyCashFlows = this.dataService.getPlanAnalysisyoyCashFlows();
      if(yoyCashFlows!== null){
        if(yoyCashFlows.Error){
          this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "CashFlowComponent-populateAppData - Error", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});                    
        } else {
          this.dataSource =  yoyCashFlows;
          this.isDataAvailable = true;                    
        }
      }      
  }

  getDisplayedColumns(){
    let displayedColumns;
    if(this.isAdditionalColumns){
      if(this.sClId){
        displayedColumns = this.displayedColumnsAdditionalWithC1C2;
      } else {
        displayedColumns = this.displayedColumnsAdditionalWithC1Only;
      }
    } else {
      if(this.sClId){
        displayedColumns = this.displayedColumnsC1C2;
      } else {
        displayedColumns = this.displayedColumnsC1Only;
      }
    }
    return displayedColumns;
  }
  ngOnDestroy(): void{
    // if(this._storeAppContextSubscription && this._storeAppContextSubscription !== null){
    //   this._storeAppContextSubscription.unsubscribe();
    // }
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
    // if(this._uiStateSubscription && this._uiStateSubscription !== null){
    //   this._uiStateSubscription.unsubscribe();    
    // }
 }

}
